export const OWNER_JARVIS_TURN_STORAGE_VERSION = 9;
export const OWNER_JARVIS_TURN_STORAGE_KEY = `wp-owner-jarvis-turn-v${OWNER_JARVIS_TURN_STORAGE_VERSION}`;
export const OWNER_JARVIS_TURN_TTL_MS = 12 * 60 * 60 * 1000;

const LEGACY_TURN_STORAGE_KEYS = Object.freeze(
  Array.from({ length: OWNER_JARVIS_TURN_STORAGE_VERSION - 1 }, (_, index) => `wp-owner-jarvis-turn-v${index + 1}`),
);

export function clearOwnerJarvisStoredTurns() {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(OWNER_JARVIS_TURN_STORAGE_KEY);
    LEGACY_TURN_STORAGE_KEYS.forEach((key) => window.sessionStorage.removeItem(key));
  } catch { /* sessionStorage opcional */ }
}

export function readOwnerJarvisStoredTurn() {
  if (typeof window === "undefined") return null;
  try {
    const parsed = JSON.parse(window.sessionStorage.getItem(OWNER_JARVIS_TURN_STORAGE_KEY) || "null");
    if (!parsed?.turn || !parsed.savedAt || Date.now() - Number(parsed.savedAt) > OWNER_JARVIS_TURN_TTL_MS) {
      clearOwnerJarvisStoredTurns();
      return null;
    }
    return parsed.turn;
  } catch {
    clearOwnerJarvisStoredTurns();
    return null;
  }
}

export function persistOwnerJarvisTurn(turn) {
  if (typeof window === "undefined") return;
  try {
    if (!turn) {
      clearOwnerJarvisStoredTurns();
      return;
    }
    window.sessionStorage.setItem(OWNER_JARVIS_TURN_STORAGE_KEY, JSON.stringify({ turn, savedAt: Date.now() }));
    LEGACY_TURN_STORAGE_KEYS.forEach((key) => window.sessionStorage.removeItem(key));
  } catch { /* sessionStorage opcional */ }
}
